import { Identify } from '@amplitude/analytics-browser'
import { plugin as engagementPlugin } from '@amplitude/engagement-browser'
import amplitudeModule from './amplitude'
import { AdminDashboardClient } from './client'
import { Action, Actor, buildEventName, Context, Namespace, Page } from './event'

const amplitude = amplitudeModule.getClient({
    identityStorage: 'localStorage',
    sessionTimeout: 5 * 60 * 1000, // 5 minutes
})

amplitude.add(engagementPlugin())

const client: AdminDashboardClient = {
    identify(page: Page): void {
        amplitude.setUserId(page.userId)

        const identifyEvent = new Identify()
        identifyEvent.set('page_name', page.pageName)
        identifyEvent.set('page_url', window.location.href)

        if (page.workflowType) {
            identifyEvent.set('workflow_type', page.workflowType)
        }

        amplitude.identify(identifyEvent)
    },
    track(actor: Actor, action: Action, context: Context = {}): void {
        amplitude.track(buildEventName(Namespace.AdminDashboard, actor, action), {
            ...context,
        })
    },
}

export default client
